import secondaryComponents from "../..";
import { EmptyShippingIcon } from "../../../../assets/svgIcons";
import { RoutedModal, WarningDialog } from "../../../common";
import { useChowdeckConnectionTable } from "./useChowdeckConnectionTable";

export const ChowdeckConnectionTable = ({
  providerName = "Chowdeck Store",
  providerKey = "chowdeck",
  allowManageAPI = true,
  chowdeckConnectionsList = [],
  metaDetails,
  gotoPage = () => {},
}) => {
  const {
    instance,
    deleteConnection,
    isDeleting,
    setDeleteConnection,
    handleDeleteConnection,
  } = useChowdeckConnectionTable({
    chowdeckConnectionsList,
    providerName,
    providerKey,
    allowManageAPI,
  });
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    instance;
  return (
    <>
      <secondaryComponents.TableHelper
        getTableProps={getTableProps}
        getTableBodyProps={getTableBodyProps}
        headerGroups={headerGroups}
        rows={rows}
        prepareRow={prepareRow}
        hasAction={true}
      >
        <div className="text-center mt-5">
          <EmptyShippingIcon />
          <h5>You have no Connections</h5>
          <p>
            Use the button above to add to connect stores. When you do, they
            will appear here.
          </p>
        </div>
      </secondaryComponents.TableHelper>

      <secondaryComponents.Pagination
        totalPageNumber={metaDetails?.last_page}
        handlePageClick={(value) => gotoPage(value?.selected + 1)}
        currentPage={metaDetails?.current_page}
      />

      <RoutedModal
        isActive={!!deleteConnection}
        width={500}
        closeModal={() => setDeleteConnection(null)}
        headerTitle="Delete Chowdeck Connection"
        style={{ height: "auto" }}
      >
        <WarningDialog
          closeModal={() => setDeleteConnection(null)}
          handler={() => handleDeleteConnection()}
          isLoading={isDeleting}
        >
          <p>
            Lumi Store:{" "}
            <span className="dark--text">
              {deleteConnection?.lumi_store?.name}
            </span>
          </p>
          <p>
            {providerName}:{" "}
            <span className="dark--text">
              {deleteConnection?.marketplace_store_name}
            </span>
          </p>
        </WarningDialog>
      </RoutedModal>
    </>
  );
};
